import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { Utils } from '@src/utils/util';
import { ImpactAnalysisHeaderComponent} from '@app/authorized/project/impact-analysis/impact-analysis-header-ang7/impact-analysis-header';
import {HttpClientModule} from '@angular/common/http';
import { DbmAdditionalOptionsModule } from '@app/shared/components/dbm-components/dbm-additional-options/dbm-additional-options.module';
@NgModule({
    imports: [SharedModule, HttpClientModule , DbmAdditionalOptionsModule ],
    declarations: [ImpactAnalysisHeaderComponent],
    entryComponents: [ImpactAnalysisHeaderComponent],
    exports: [ImpactAnalysisHeaderComponent],
    providers: [ Utils]
})

export class ImpactAnalysisHeaderModule{}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/impact-analysis/impact-analysis-header-ang7/impact-analysis-header.module.ts